// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__EZ92F","paramInput":"JobSimulator_paramInput__6KuEP","input":"JobSimulator_input__3tY3A"};